<template>
	<div class="py-5 pale-bg">
	<b-container>
			<head-title title="contact"></head-title>
		<h2 class="mt-5" data-aos="fade-up"  data-aos-duration="800" data-aos-offset="-500">Let's work on something nice.</h2>
		<a href="mailto:davidenochaji@gmail.com" class="black-text d-flex align-items-center email-link" data-aos="fade-up"  data-aos-duration="800" data-aos-offset="-800"><h2 class="text-underline mt-3 mr-4">davidenochaji@gmail.com</h2> <svg xmlns="http://www.w3.org/2000/svg" width="25.342" height="25.197" viewBox="0 0 25.342 25.197" class="d-none d-md-block"><g transform="translate(0 1.5)"><path d="M911.487,278.077h23.842v22.588" transform="translate(-911.487 -278.077)" fill="none" stroke="#8d140e" id="g1" stroke-width="3"/><path d="M936.329,277.077l-22.637,22.637" transform="translate(-912.487 -277.077)" fill="none" stroke="#8d140e" id="g2" stroke-width="3"/></g></svg></a>
	</b-container>
	</div>
</template>

<script>
import HeadTitle from '../components/HeadTitle'
import {BContainer} from 'bootstrap-vue'
export default {
	components:{
		HeadTitle,
		BContainer
	}
}
</script>

<style>
.text-underline{
	text-decoration: underline;
	
}
.email-link{
	word-break: break-all;
}
.email-link h2{
	transition:all 0.3s ease-in-out;
}
.email-link:hover{
	color:#8d140e;
}
.email-link:hover svg #g1, svg #g2{
	stroke:#8d140e;
}
.email-link:hover h2{
	margin-right:60px!important;
	transition:all 0.5s ease-in-out;
}
</style>